module.exports = __webpack_public_path__ + "assets/img/19f1-un.svg";